module.exports = __webpack_public_path__ + "img/Screenshot_2021-10-28-16-21-27-308_com.pinkcoffee.sexbattle.9450d279.jpg";